module.exports = __webpack_public_path__ + "static/img/chsnyqqx.2ce7208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/chsnyqqx.png
// module id = LGP3
// module chunks = 0